import { Link } from "react-router-dom";
import { EmptyState } from "@/components/ui";

export function NotFound() {
  return (
    <EmptyState
      title="Sayfa bulunamadı"
      description="Aradığınız adres bu uygulamada yok."
      action={<Link to="/">Genel bakışa dön</Link>}
    />
  );
}
